import { getChainIcon } from '@particle-network/connector-core';
import { useMemo, useRef, useState } from 'react';
import DownArrowIcon from '../../assets/icons/DownArrowIcon';
import ErrorIcon from '../../assets/icons/ErrorIcon';
import MoreOptionsIcon from '../../assets/icons/MoreOptionsIcon';
import { useAccount } from '../../hooks/useAccount';
import { useAddress } from '../../hooks/useAddress';
import { useChains } from '../../hooks/useChains';
import useLocales from '../../hooks/useLocales';
import { useRouter } from '../../hooks/useRouter';
import { useSmartAccount } from '../../hooks/useSmartAccount';
import { RoutePath } from '../../pages';
import { shortAddress } from '../../utils';
import { getChainDisplayName } from '../../utils/chains';
import ChainDropdown from '../chainDropdown';
import HorizontalResizeAnimation from '../horizontalResizeAnimation';
import WalletAAIcon from '../walletAAIcon';
import WalletIcon from '../walletIcon';
import {
  StyleAddressSection,
  StyleChainIcon,
  StyleChainName,
  StyleChainSection,
  StyleConnectedWidgetContainer,
  StyleDivider,
  StyleInfoBox,
  StyleSwitchNetwork,
  StyleWalletAddress,
} from './styles';

const ConnectedWidget = () => {
  const locales = useLocales();
  const { chain } = useAccount();
  const walletAddress = useAddress();
  const { navigate } = useRouter();
  const chains = useChains();
  const smartAccount = useSmartAccount();

  // @ts-ignore
  const aaIconName = smartAccount?.smartAccountContract?.name?.toUpperCase();

  const [chainDropdownVisible, setChainDropdownVisible] = useState(false);
  const leftRef = useRef<HTMLDivElement>(null);

  /**
   * 是否支持当前链
   */
  const supportChain = useMemo(() => {
    return chains.some((item) => item.id === chain?.id);
  }, [chain, chains]);

  const chainName = useMemo(() => {
    const chainName = getChainDisplayName(chain);
    const maxChainNameLength = window.screen.width < 400 ? 9 : 18;
    return chainName?.length > maxChainNameLength ? `${chainName.slice(0, maxChainNameLength)}...` : chainName;
  }, [chain]);

  return (
    <StyleConnectedWidgetContainer>
      <StyleInfoBox>
        <StyleChainSection
          ref={leftRef}
          selected={chains?.length > 1 || !supportChain}
          onClick={() => {
            if (chains?.length > 1 || !supportChain) {
              setChainDropdownVisible(!chainDropdownVisible);
            }
          }}
        >
          <div className='wrap'>
            {supportChain ? (
              <>
                {chain && <StyleChainIcon src={getChainIcon(chain)} alt='' />}
                <HorizontalResizeAnimation>
                  <StyleChainName>{chainName}</StyleChainName>
                </HorizontalResizeAnimation>
              </>
            ) : (
              <StyleSwitchNetwork>
                <ErrorIcon />
                <HorizontalResizeAnimation>{locales.switchNetwork}</HorizontalResizeAnimation>
              </StyleSwitchNetwork>
            )}
            {(chains?.length > 1 || !supportChain) && (
              <DownArrowIcon
                width={10}
                height={10}
                spin={!!chainDropdownVisible}
                color={supportChain ? 'var(--pcm-body-color-secondary)' : 'var(--pcm-error-color)'}
              />
            )}
          </div>
        </StyleChainSection>
        <StyleDivider />
        <StyleAddressSection
          style={{ cursor: 'pointer' }}
          onClick={() => {
            navigate(RoutePath.WalletInfo);
          }}
        >
          <div className='wrap'>
            {aaIconName ? <WalletAAIcon size={20} aaName={aaIconName} /> : <WalletIcon size={20} />}
            <HorizontalResizeAnimation>
              <StyleWalletAddress>{shortAddress(walletAddress || '')}</StyleWalletAddress>
            </HorizontalResizeAnimation>
            <MoreOptionsIcon />
          </div>
        </StyleAddressSection>
      </StyleInfoBox>
      <ChainDropdown
        visible={chainDropdownVisible}
        setVisible={setChainDropdownVisible}
        clickAwayElements={[leftRef as any]}
        supportChain={supportChain}
      />
    </StyleConnectedWidgetContainer>
  );
};

export default ConnectedWidget;
